import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import UserInviteByEmailUI from './UserInviteByEmailUI.js'

class UserInviteByEmailSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // email
      email: '',
      emailError: null,
      // name
      firstName: '',
      lastName: '',
      firstNameError: null,
      lastNameError: null,
      // role
      accountRoleId: '',
      accountRoleList: null,
      // project
      projectList: null,
      // project role
      projectRoleId: '',
      projectRoleList: null,
      // email
      message: '',
      messageError: null,
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <UserInviteByEmailUI
        context={this.props.context}
        messageList={this.props.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // email
        email={this.state.email}
        onEmailChange={(event) => {this.setState({email: event.target.value})}}
        emailError={this.state.emailError}
        setEmailError={(error) => {this.setState({emailError: error})}}
        // name
        firstName={this.state.firstName}
        lastName={this.state.lastName}
        onFirstNameChange={(event) => {this.setState({firstName: event.target.value})}}
        onLastNameChange={(event) => {this.setState({lastName: event.target.value})}}
        firstNameError={this.state.firstNameError}
        lastNameError={this.state.lastNameError}
        setFirstNameError={(error) => {this.setState({firstNameError: error})}}
        setLastNameError={(error) => {this.setState({lastNameError: error})}}
        // account role
        accountRoleId={this.state.accountRoleId}
        accountRoleList={this.state.accountRoleList}
        onaccountRoleIdChange={(event) => {this.setState({accountRoleId: event.target.value})}}
        // project
        projectList={this.state.projectList}
        onProjectChange={this.onProjectChange}
        // project role
        projectRoleId={this.state.projectRoleId}
        projectRoleList={this.state.projectRoleList}
        onprojectRoleIdChange={(event) => {this.setState({projectRoleId: event.target.value})}}
        // email
        message={this.state.message}
        onMessageChange={(event) => {this.setState({message: event.target.value})}}
        messageError={this.state.messageError}
        setMessageError={(error) => {this.setState({messageError: error})}}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
      />
    )
  }

  UNSAFE_componentWillMount() {
    let context = this.props.context
    this.getAccountRoles(context)
    if (context.session.appCode === 'projectapp') {
      this.getProjectRoles(context)
      this.getProjects(context)
    }
  }

  onProjectChange = (event) => {
    let projectId = event.currentTarget.getAttribute('data-key')
    this.state.projectList.forEach(project => {
      if (project.projectId === projectId)
        project.selected = !project.selected
    })
    this.setState({projectList: this.state.projectList})
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    let projectIds = null
    if (context.session.appCode === 'projectapp') {
      projectIds = this.state.projectList.filter(project => project.selected)
        .map(project => project.projectId).join(',')
    }

    RestApiUtils.post(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/users`,
      this.onSubmitCallback, {
        email: this.state.email,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        accountRoleId: this.state.accountRoleId,
        appData: projectIds,
        appRoleId: this.state.projectRoleId,
        message: this.state.message,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'email':
          this.setState({emailError: error.message})
          break;
        case 'firstName':
          this.setState({firstNameError: error.message})
          break;
        case 'lastName':
          this.setState({lastNameError: error.message})
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})

    if (this.state.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.AccountUsers(this.props.context.session.accountId))
      // also need to refresh task tree and project users cache as deleted users are removed from project
      CacheManager.removeByPrefix('TaskTree')
      CacheManager.removeByPrefix('ProjectUsers')

      setTimeout(() => {
        this.setState({
          email: '',
          firstName: '',
          lastName: '',
          successMsg: null
        })
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  getProjects(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/projects`,
      cacheKey: CacheKeys.Projects(context.session.accountId, context.session.userId),
      callback: this.getProjectsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectsCallback = (response) => {
    if (response.errorList.length > 0) {
      this.props.history.replace('/projects')
      return
    }
    let projectList = response.projectList
      .filter(project => project.status !== 'archived' && project.roleId)
      .map(project => {
        project.selected = false
        return project
      })
    this.setState({projectList : projectList})
  }

  getAccountRoles(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/roles/account`,
      cacheKey: CacheKeys.Roles('account', context.locale),
      callback: this.getAccountRolesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {locales: context.locale})
  }

  getAccountRolesCallback = (response) => {
    let nonOwnerRoleList = response.roleList.filter(role => !role.ownerRole).map(role => ({key: role.roleId, value: role.roleName}))
    this.setState({
      accountRoleList: nonOwnerRoleList,
      accountRoleId: nonOwnerRoleList[1].key
    })
  }

  getProjectRoles(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/roles/project`,
      cacheKey: CacheKeys.Roles('project', context.locale),
      callback: this.getProjectRolesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {locales: context.locale})
  }

  getProjectRolesCallback = (response) => {
    let projectRoleList = response.roleList.map(role => ({key: role.roleId, value: role.roleName}))
    this.setState({
      projectRoleList: projectRoleList,
      projectRoleId: projectRoleList[1].key
    })
  }

}

export default withRouter(UserInviteByEmailSF)
